import { useSearchState } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	nOfFilters: number;
}>;

export function useTopicsMobileButton(): Result {
	const state = useSearchState();

	return {
		data: {
			nOfFilters: state.topics.length,
		},
	};
}
